import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getCourses } from '../../actions/courseActions';
import { setTheme } from '../../actions/layoutActions';
import Course from './Course';
import Spinner from '../common/Spinner/Spinner';


class CourseContainer extends Component {
  static propTypes = {
    courses: PropTypes.array.isRequired,
    match: PropTypes.object.isRequired,
    getCourses: PropTypes.func.isRequired,
    setTheme: PropTypes.func.isRequired
  }

  state = {
    modal: false
  };

  componentDidMount() {
    if (this.props.courses.length === 0) {
      this.props.getCourses();
    }

    this.props.setTheme('RED');
  }

  toggleModalState = () => {
    this.setState({ modal: !this.state.modal }, () => {
      if (this.state.modal) document.body.classList.add('disable-scroll');
      else document.body.classList.remove('disable-scroll');
    });
  }

  render() {
    const { courses, match } = this.props;
    const course = courses.filter(course => course.slug === match.params.slug)[0];

    if (courses.length === 0) {
      return (
        <Spinner style={{ marginTop: '200px', marginBottom: '200px' }} />
      );
    } else if (!course) {
      return (
        <h5>
          Nem található kurzus
        </h5>
      );
    } else {
      return (
        <Course
          title={course.title}
          content={course.description.long}
          image={course.image}
          modal={this.state.modal}
          toggleModalState={this.toggleModalState}
        />
      );
    }
  }
}


const mapStateToProps = (state) => ({
  courses: state.courses.courses
});

const mapDispatchToProps = {
  getCourses,
  setTheme
};

export default connect(mapStateToProps, mapDispatchToProps)(CourseContainer);



// WEBPACK FOOTER //
// ./src/components/Course/CourseContainer.js